import React from "react";
import './PurchaseResponseMessage.css'

function PurchaseResponseMessage(props) {
    let icon = '';
    let typeMessage='';

    switch(props.purchaseResponseData.type){
        case 'success':
            icon = 'check';
            typeMessage = 'success'
            break;
        case 'warning':
            icon = 'exclamation';
             typeMessage = 'warning'
            break;
        case 'error':
            icon = 'times';
             typeMessage = 'error'
            break;
    }

    return (
        <div className= {"purchaseResponseMessage " + typeMessage}  >
            <span className={"purchaseResponseMessageSignal" + " " + props.purchaseResponseData.type} >
					<i className={"fa fa-" + icon}   /> 
			</span>	
            {props.purchaseResponseData.message}
        </div>
    )
}

export default PurchaseResponseMessage;